import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import API from "../../API";
import CustomButton from "../Controls/CustomButton";

/** Public page: coworker confirms employment link via emailed token. */
export default function CoworkerVerify() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("confirming");
  const [message, setMessage] = useState("Confirming coworker connection…");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!token) {
        setStatus("error");
        setMessage("Missing verification token.");
        return;
      }
      try {
        const resp = await API.postAsync("/Connection/CoworkerConfirm", { Token: token });
        if (cancelled) return;
        if (resp && resp.ok) {
          setStatus("ok");
          setMessage("Thanks — coworker connection verified.");
          toast.success("Coworker verified");
        } else {
          const msg =
            (resp && resp.jsonData && (resp.jsonData.message || resp.jsonData.Message)) ||
            "Verification failed";
          setStatus("error");
          setMessage(msg);
          toast.error(msg);
        }
      } catch (e) {
        if (cancelled) return;
        setStatus("error");
        setMessage(e?.message || "Verification failed");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div className="pagebody" style={{ maxWidth: 480, margin: "2rem auto", padding: "1rem" }}>
      <h1>Coworker verification</h1>
      <p data-testid="coworker-verify-status">{message}</p>
      {status === "ok" && (
        <CustomButton type="button" variant="contained" color="primary" onClick={() => navigate("/")}>
          Continue
        </CustomButton>
      )}
    </div>
  );
}
